


































import { ColorsList, getCurrentTimestamp, getUniqueId, ID } from '../../core/utils';
import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { AuthStoreHelper, RootStoreHelper } from '../../core/mixins';
import { ChatbotConversationStatus, ChatbotMsg, ChatbotMsgResponse, ChatbotSendMessage, ChatbotUserInfo } from '../models/ChatbotMsg';
import { dateTypes } from '../../core/models';
import { ChatbotProperties, ChatConversationStatus, MessageType } from '../models/ChatConstants';
@Component({
    components: {
        
    }
})
export default class ChatbotUserMessage extends Mixins(RootStoreHelper, AuthStoreHelper) {
    message: string = '';
    loading: boolean = true;
    bgUserInput: string = '#F5CDA4';
    textAreaColor: string = ColorsList.dark_smartway;
    newMessageCount: number = 0;
    pollingActive: boolean = true;
    messageWasSent: boolean = false;
    @Watch('$_getChatbotPendingDeleteConversation')
    onPendingDeleteConversationChanged(val: boolean, oldVal: boolean){
      this.message = '';
    }

    get currentConversationIsWithStatusDisabled(){
      if(this.$_getChatbotPendingConversationStatus.length == 0) return false
      return this.$_getChatbotPendingConversationStatus.includes(this.currentConversationId)
    }

    get currentConversationIsPendingPreviousMessages(){
      if(this.$_getConversationsAskingForPreviousMessages.length == 0) return false
      return this.$_getConversationsAskingForPreviousMessages.includes(this.currentConversationId)
    }

    get canSubmitMessage(){
 


      if(
        this.$_getChatbotPendingConversations || 
        this.$_getChatbotPendingMsgsForConversation || 
        this.$_getChatbotConversations.length == 0 ||
        this.$_getChatbotPendingDeleteConversation ||
        this.currentConversationIsWithStatusDisabled ||
        this.currentConversationIsPendingPreviousMessages
      ){
        return false
      }
      return true
    }

  get getLabelForTextArea(){
    if(this.$_getChatbotPendingMsgsForConversation || this.$_getChatbotPendingConversations || this.$_getChatbotPendingDeleteConversation){
      return 'Procesando...'
    }
    return 'Escribe tu consulta...'
  }

    triggerSendMessage(){
      if(!this.canSubmitMessage || this.messageWasSent) return

      let userMsg = this.message;
      this.clearUserMessage();
      this.submitMessageToServer(userMsg);
    }

    get currentConversationId(){
      if(!this.$_getChatbotConversations) return -1
      if(this.$_getChatbotConversations.length == 0){
        return -1
      }
      return Number(this.$_getChatbotConversations[0].id)
    }

    beforeDestroy() {
      this.pollingActive = false; // Detiene el polling antes de que el componente sea destruido
    }

    submitMessageToServer(userMsg: string){
      /* Envío el mensaje al servidor */
      let config: ChatbotSendMessage = {
        conversation_id: this.currentConversationId,
        message: userMsg.trim()
      }
      this.addUserMessageToStore(userMsg);
      this.addTemporaryBotMessage();
      this.messageWasSent = true;
      this.$_chatbotSetStatusForConversation({
        conversation_id: config.conversation_id,
        status: ChatConversationStatus.DISABLED
      })
      
      this.$_chatbotSendMessage(
        config
      ).then((res: ChatbotMsgResponse) => {
          this.$_setPendingConversationsStatus(config.conversation_id)
      }).catch((err) => {
        this.$_chatbotRemoveLastMessage(this.currentConversationId);
        this.addMessageWithError();
      }).finally(() => {        
        this.$_chatbotPendingRequest(false);
        this.messageWasSent = false;
      })
    }


   
    clearUserMessage(){
      /* Limpia el campo de texto  */
      this.message = '';
    }


    addUserMessageToStore(userMsg: string){
      /* Luego de que el usario envia el msg, lo agrego a la lista de mensajes */
      this.addMessageToStore(userMsg, false)
    }

    addTemporaryBotMessage(){
      /* Agrego un mensaje temporal para agregar el indicador de cargando el mensaje */
      this.addMessageToStore('', true)
    }

    addMessageWithError(){
      /* si falla el envio de msg, agrego un msg de error */
      this.addMessageToStore('Ocurrio un error, por favor...', false, true)
    }

    addMessageToStore(text: string, isBot = false, withError = false){
      let userInfo: ChatbotUserInfo = {
          id: this.$_getAuth ? this.$_getAuth.id : -1,
          username: this.$_getAuth ? this.$_getAuth.username : ''
        }
      let message: ChatbotMsg = {
        id: getUniqueId(),
        conversation_id: this.currentConversationId,
        message: text,
        message_type: isBot ? MessageType.BOT : MessageType.USER,
        timestamp: getCurrentTimestamp(dateTypes.globalFilterDateFormat),
        user: isBot || withError ? null : userInfo,
        ...(withError ? { error: true } : {}),
      };
      this.$_chatbotAddNewMessage({
        conversation_id: this.currentConversationId,
        message: message
      })
    }

    

   
}
